import { render, staticRenderFns } from "./dcTakeBackWindow.vue?vue&type=template&id=6b6f0ef7&scoped=true&"
import script from "./dcTakeBackWindow.vue?vue&type=script&lang=js&"
export * from "./dcTakeBackWindow.vue?vue&type=script&lang=js&"
import style0 from "./dcTakeBackWindow.vue?vue&type=style&index=0&id=6b6f0ef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f0ef7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6f0ef7')) {
      api.createRecord('6b6f0ef7', component.options)
    } else {
      api.reload('6b6f0ef7', component.options)
    }
    module.hot.accept("./dcTakeBackWindow.vue?vue&type=template&id=6b6f0ef7&scoped=true&", function () {
      api.rerender('6b6f0ef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/DocumentCirculation/dcTakeBackWindow.vue"
export default component.exports